import banner from '../assets/empower-your-community.webp'
import arrow from '../assets/right-arrow.svg'
import networking from '../assets/networking.webp'
import '../layouts/ansysoft.css'
import { Link } from 'react-router-dom'
import Footer from '../components/footer'

function Main() {

    

    return (
        <>
            <div className="w-100 banner-bg-home" data-aspect-ratio="16 / 9">
                <div className="banner-bg-1">
                    <div className="container banner-wrap-home">
                        <div className="banner-home">
                            <h1 className="heading-1-home">WebBull is for everyone</h1>
                            <p className="description-1-home mt-3 mt-md-5">Our community-based membership plans offer a range of benefits and opportunities for individuals to engage and participate in a collective environment.</p>
                            <Link to="/signin" className="btn-main main-width btn-outline-main">START NOW<img src={arrow} alt="===>" className='arrow' /></Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-100 why-prometa-bg-home">
                <div className="container why-prometa-home">
                    <h2 className="small-heading-2-home">WHY WEBBULL</h2>
                    <h3 className="heading-2-home">
                        <span>Collaboration and </span>
                        <span>Social Cohesion</span>
                    </h3>
                    <p className="para-2-home">Involving community members in <span className="gtext-2">decision-making</span> processes,
                        they develop a sense of <span className="gtext-21">ownership</span> and <span
                            className="gtext-22">empowerment</span> over the initiatives undertaken.</p>
                    <div className="grey-card-group mt-5 flex-column flex-md-row">
                        <div className="grey-card">
                            <div className="card-img-2">
                                <h3 className="card-heading">Highly Secured</h3>
                                <p className="card-text">The functioning of WebBull is fully blockchain-protected.</p>
                            </div>
                        </div>
                        <div className="grey-card">
                            <div className="card-img-21">
                                <h2 className="card-heading">Easy Interface</h2>
                                <p className="card-text">Beginners willing to start their journey on this platform can easily do so.
                                    Beginners do not require any special knowledge.</p>
                            </div>
                        </div>
                        <div className="grey-card">
                            <div className="card-img-22">
                                <h2 className="card-heading">No Additional Fees</h2>
                                <p className="card-text">WebBull does not charge any additional fees to all of its users. All the
                                    earnings will only come to your wallet from the activity of other members who participate in
                                    our community program.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-100 entrepreneur-bg">
        <div className="container entrepreneur-wrap">
            <div className="entrepreneur">
                <h2 className="heading-3">You are an <span className="inlinetext-3">Entrepreneur</span></h2>
                <p className="para-3">Exploring the Boundaries of Blockchain Technology: Unveiling Frontiers in Innovation
                    and Possibility</p>
            </div>
        </div>
    </div>

    <div className="w-100 collaboration-bg">
        <div className="container collaboration">
            <h2 className="heading-4">Embrace the Power of Collaboration</h2>
            <p className="para-4">Join our global community of independent entrepreneurs, unlock your potential, and embark
                on a journey of exploration together.</p>
            <div className="networking-wrap d-flex justify-content-center">
                <img src={networking} alt="Networking" className="networking" width="965px" height="323px"/>
            </div>
        </div>
    </div>

    <Footer/>
        </>
    )
}

export default Main;
